import numeral from 'numeral';

export const selectEntryTotal = (entries = []) => {
  return entries.map((entry) => {
      return entry.line_items.reduce((total, { amount }) => {
          const withoutDecimal = parseFloat(amount, 10) * 100;
          return total + withoutDecimal;
      }, 0);
    }).reduce((total, subAmount) => {
        return total + subAmount;
    }, 0);
};

export const formattedEntriesTotal = (total) => {
  return numeral(total).format('$0,0.00');
};

export const entryTypeBalance = (entries, entry_type) => {
  const filteredEntries = entries.filter(entry => (
    entry.entry_type === entry_type
  ));
  return selectEntryTotal(filteredEntries) / 100;
};

export const positiveNumber = (value) => {
  return value >= 0;
};



// WEBPACK FOOTER //
// ./src/selectors/entriesTotal.js